<template>
    <div
      class="relative px-5 space-y-16 overflow-hidden md-max:pb-16 md-max:mt-8 lg:px-14 xl:px-20 2xl:px-12 md:py-14 lg:py-16 2xl:py-24 md:space-y-14 lg:space-y-16 2xl:space-y-24">
      <div class="w-full mx-auto max-w-7xl">
        <div v-if="showTitle" class="text-3xl text-center lg:text-4xl font-ww-bold lg:mb-14 mb-7" v-html="title"></div>
        <div
          class="flex flex-wrap justify-between space-y-24 md:flex-nowrap md:space-y-0 md:space-x-7 lg:space-x-16 xl:space-x-12">
          <div class="relative justify-center w-full py-6 bg-bottom bg-no-repeat lg:py-12 md:w-1/2" style="background-image: url('assets/images/bg-testimonials.png');" v-for="(testimonial, index) in testimonials"
            :key="index">
            <div class="relative flex items-start justify-center w-full text-center">
             
              <h2 :class="textLeft ? 'text-left' : 'text-center'" class=" w-11/12 z-10 relative max-w-md pb-12 text-base font-ww-regular h4 lg:text-xl !leading-6 md:text-left text-center"
                v-html="testimonial.quote"></h2>
            </div>
       
            <div class="detailbox flex items-center w-full max-w-lg absolute -bottom-16 us-max:-bottom-20 z-10 space-x-3.5 md:space-x-6">
              <div class="w-full text-right pt-2.5 lg:pt-6">
                <div class="lg:text-base text-sm font-ginger pb-0.5" v-html="testimonial.author"></div>
                <div class="h-8 text-xs" v-html="testimonial.profession"></div>
              </div>
              <nuxt-img class="block w-20 -mt-10 lg:w-28 xl:w-30 md:-mt-12 xl:-mt-16" width="121" height="121"
                loading="lazy" format="webp" :alt="testimonial.author" :src="testimonial.imageSrc"></nuxt-img>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  const props = defineProps({
    title: {
      type: String,
      default: "Recommended by Professionals"
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    textLeft: {
      type: Boolean,
      default: false
    },
    testimonials: {
      type: Array,
      default: () => [
        {
          quote: 'Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.',
          author: 'Dr. Aaron Oxenrider',
          profession: 'Board Certified Chiropractic Physician and Regenerative Medicine Expert',
          imageSrc: 'assets/images/doctor2.jpg'
        },
        {
          quote: 'Low acid coffee Best tasting low acid coffee ever! And it’s great on your teeth!',
          author: 'Dr. Gary Sanchez',
          profession: 'Board Certified Dentist',
          imageSrc: 'assets/images/doctor1.jpg'
        }
      ]
    }
  });
  
  defineBuilderComponent({
    friendlyName: "TestimonialsReviewGrid",
    inputs: [
      {
        name: "title",
        type: "string",
        friendlyName: "Title",
        defaultValue: "Recommended by Professionals"
      },
      {
        name: "showTitle",
        type: "boolean",
        friendlyName: "Show Title",
        defaultValue: false
      },
      {
        name: "textLeft",
        type: "boolean",
        friendlyName: "Text Left",
        defaultValue: false
      },
      {
        name: "testimonials",
        type: "list",
        friendlyName: "Testimonials",
        subFields: [
          {
            name: "quote",
            type: "richText",
            friendlyName: "Quote",
            defaultValue: "Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation."
          },
          {
            name: "author",
            type: "string",
            friendlyName: "Author",
            defaultValue: "Dr. Aaron Oxenrider"
          },
          {
            name: "profession",
            type: "string",
            friendlyName: "Profession",
            defaultValue: "Board Certified Chiropractic Physician and Regenerative Medicine Expert"
          },
          {
            name: "imageSrc",
            type: "file",
            friendlyName: "Author Image",
            allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
            defaultValue: "assets/images/doctor2.jpg"
          }
        ],
        defaultValue: [
          {
            quote: "Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.",
            author: "Dr. Aaron Oxenrider",
            profession: "Board Certified Chiropractic Physician and Regenerative Medicine Expert",
            imageSrc: "assets/images/doctor2.jpg"
          },
          {
            quote: "Low acid coffee Best tasting low acid coffee ever! And it’s great on your teeth!",
            author: "Dr. Gary Sanchez",
            profession: "Board Certified Dentist",
            imageSrc: "assets/images/doctor1.jpg"
          }
        ]
      }
    ]
  });
  </script>
  